var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-screen h-body" }, [
    _c(
      "div",
      {
        staticClass:
          "w-full h-full flex flex-col items-center justify-center gap-8"
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass:
              "font-semibold text-light-purple-400 hover:text-dark-purple-200",
            attrs: { to: "/clients" }
          },
          [_vm._v("\n      Back to home\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "font-logo font-bold text-center" }, [
      _c("div", { staticClass: "text-6xl" }, [_vm._v("404")]),
      _vm._v(" "),
      _c("div", { staticClass: "text-2xl" }, [_vm._v("Page Not Foünd")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a86191f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a86191f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = null
// module chunks = 